export const truncate = (props: { value: string; amount: number }) => {
    const { value, amount } = props;
    if (value.length <= amount) return value;
    return `${value.slice(0, amount - 3)}...`;
};
